// removed by extract-text-webpack-plugin
module.exports = {"controlLabel":"D5t9UMGYRVygk3rhLomhj","fontReg":"_3rK9_p_pYyzVWTAf_1H8vl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdateWireDescriptionsForm/styles.css
// module id = 3248
// module chunks = 0